<template>
    <div>
        <spinner v-if="loading" class="center" />
        <div v-if="!loading" class="row">
            <div v-if="!translationStage" class="col s12 m8 offset-m2">
                <div class="card">
                    <div class="card-content">
                        <span class="card-title">Language Selection</span>
                        <p>Choose the language you are want to translate.</p>
                        <div class="row selectors">
                            <div class="col s12 m6">
                                <LanguagePicker v-model="fromLanguage" :label="'From'" />
                            </div>
                            <div class="col s12 m6">
                                <LanguagePicker v-model="toLanguage" :label="'To'" />
                            </div>
                        </div>
                    </div>
                    <div class="card-action right-align">
                        <a href="#" @click="confirmLanguages" :class="{'grey-text': !fromLanguage || !toLanguage || fromLanguage === toLanguage}">next</a>
                    </div>
                </div>
            </div>
            <div v-if="translationStage && currentPhrase" class="col s12">
                <span class="badge">{{missingTranslations.length}} left</span>
                <div class="progress">
                    <div class="determinate" :style="{'width': (1-missingTranslations.length/$store.phrases.length)*100+'%'}"></div>
                </div>
                <div class="card">
                    <div class="card-content">
                        <span class="card-title">Translation</span>
                        <p>{{existingTranslation}}</p>
                        <div class="row input-row">
                            <div class="input-field col s12">
                                <input placeholder="Translation" v-model="translation" type="text" dir="auto">
                            </div>
                        </div>
                    </div>
                    <div class="card-action right-align">
                        <a href="#" @click="skip" class="left" :class="{'grey-text': !fromLanguage || !toLanguage}">Skip</a>
                        <a href="#" @click="save" :class="{'grey-text': !fromLanguage || !toLanguage}">save</a>
                    </div>
                </div>
            </div>
            <div v-if="translationStage && !currentPhrase" class="col s12">
                <div class="card">
                    <div class="card-content">
                        <span class="card-title">Nothing left to translate</span>
                        <p>The selected language has translations for all phrases.</p>
                    </div>
                    <div class="card-action right-align">
                        <a href="#" @click="goToLanguageSelection">Change Languages</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .selectors {
        margin-top: 2em;
    }

    .input-row {
        margin-bottom: 0 !important
    }

    .right-align>a:last-child {
        margin-right: 0 !important
    }

    .progress {
        width: auto !important;
        margin-top: 10px !important
    }

    .center {
        position: relative;
        left: 50%;
        margin-top: 5%
    }
</style>
<script>
    import Spinner from "../components/Spinner";
    import LanguagePicker from "../components/LanguagePicker";

    export default {
        name: 'translatorView',
        components: {
            Spinner,
            LanguagePicker
        },
        data() {
            return {
                loading: true,
                fromLanguage: null,
                toLanguage: null,
                translationStage: false,
                skipList: [],
                translation: ""
            }
        },
        methods: {

            /**
             * Confirm picked languages and continue to translation stage
             */
            confirmLanguages() {
                if (!this.toLanguage || !this.fromLanguage) {
                    this.toast('You have to select two languages, in order to continue')
                    return
                } else if (this.toLanguage === this.fromLanguage) {
                    this.toast('You can\'t select the same language twice')
                    return
                }
                this.translationStage = true
            },
            /**
             * Save the current phrase and continue to the next one
             */
            save() {
                if (this.translation.length > 0) {
                    var updatedPhrase = JSON.parse(JSON.stringify(this.currentPhrase))
                    this.loading = true
                    this.$store.putTranslation(updatedPhrase.id,{
                        language: this.toLanguage,
                        text: this.translation
                    }).then(() => {
                        this.loading = false
                    }).catch(() => this.toast("Failed to save phrase"))
                    this.translation = ""
                } else {
                    this.toast("You can't save an empty translation")
                }
            },
            /**
             * Skip a phrase
             */
            skip() {
                this.skipList.push(this.currentPhrase.id)
            },
            /**
             * Go back to the language selection
             */
            goToLanguageSelection() {
                this.translationStage = false
                this.toLanguage = null
                this.fromLanguage = null
            },
            /**
             * Help method for toasts
             */
            toast(text) {
                M.toast({
                    html: text
                })
            }
        },
        created() {
            this.$store.getPhrases().then(() => {
                this.loading = false
            }).catch(() => {
                this.toast("Failed to retrieve the lastest phrases")
            })
        },
        computed: {
            /**
             * Returns a list of phrases that lacks translations in choosen language
             */
            missingTranslations() {
                var phraseNoTranslation = this.$store.phrases.filter(p => !p.translations);
                var obj = {
                        text: "",
                        language: ""
                    }
                phraseNoTranslation.forEach(response => {
                    if(response.translations == null){
                     response.translations = []
                    response.translations.push(obj)
                } 
                });
                return this.$store.phrases.filter(p => !p.translations.some(t => t.language == this.toLanguage) && p.translations.some(t => t.language == this.fromLanguage) && !this.skipList.some(id => id === p.id))
            },
            /**
             * Returns current phrase
             */
            currentPhrase() {
                return this.missingTranslations[0]
            },
            /**
             * Returns the translations for the language to translate from
             */
            existingTranslation() {
                return this.currentPhrase.translations.filter(t => t.language == this.fromLanguage)[0].text
            }
        },
        updated() {
            M.updateTextFields();
        },

    }
</script>


// WEBPACK FOOTER //
// src/views/TranslatorView.vue